import { PIN_SIZE } from './constants'

export const pinsMatch = (values,strings, pin1, pin2) => {
    const errors = {};
    const pinObj = Object.keys(values)
        .filter(key => key.indexOf(pin1) ===0)
        .reduce((obj, key) => {
            obj[key] = values[key];
            return obj;
        }, {});
    let pin = Object.values(pinObj).join();
    const confPinObj = Object.keys(values)
        .filter(key => key.indexOf(pin2) ===0)
        .reduce((obj, key) => {
            obj[key] = values[key];
            return obj;
        }, {});
    let confPin = Object.values(confPinObj).join();
    if (pin !== confPin){

        errors[pin2+PIN_SIZE] = strings.noMatchPins;
    }
    return errors;
}

export const getPin = (values, pinName) => {
    let pinString='';
    const pinObj = Object.keys(values)
        .filter(key => key.indexOf(pinName) ===0)
        .reduce((obj, key) => {
            //obj[key] = values[key];
            return pinString += values[key];
            //return obj;
        }, {});
    return pinObj;
}

export const validatePin = (values, strings, pinName) => {
    // needs to be x 4, and digits only
    const errors = {};
    const filtered = Object.keys(values)
        .filter(key => key.indexOf(pinName) ===0)
        .reduce((obj, key) => {
            obj[key] = values[key];
            return obj;
        }, {});
    if (!filtered || Object.keys(filtered).length !== PIN_SIZE){
        errors[pinName+PIN_SIZE] = strings.pinFour;
    }
    if (Object.values(filtered).findIndex(value => !/^[0-9]{1}$/.test(value)) !== -1){
        errors[pinName+PIN_SIZE] = strings.pinFour;
    }
    return errors;
}
